import * as service from "../common/service";
import { getCurrentApiBaseUrl } from "../common/constants";

// Dynamic API URL functions that get the current API base URL at runtime
const getUserApi = () => `${getCurrentApiBaseUrl()}/observer/observers`;
const getInvitesListApi = () => `${getCurrentApiBaseUrl()}/observer/observees`;
const getActionInviteApi = () => `${getCurrentApiBaseUrl()}/observer`;

const observeService = {
  getObserveList: (payload) => {
    return service.get(`${getUserApi()}${observeService.filterConfig(payload)}`, {});
  },
  getInvitesList: (payload) => {
    return service.get(`${getInvitesListApi()}${observeService.filterConfig(payload)}`, {});
  },
  actionInvite: (payload) => {
    return service.putJson(`${getActionInviteApi()}`, payload);
  },
  filterConfig: (payload) => {
    let filter = "";
    if (payload && Object.keys(payload).length > 0) {
      filter = Object.keys(payload).reduce(
        (acc, val, index) =>
          Object.keys(payload).length - 1 === index
            ? `${acc}${val}=${payload[val]}`
            : `${acc}${val}=${payload[val]}&`,
        "?"
      );
    }
    return filter;
  }
};

export default observeService;
